
import { useDispatch, useSelector } from "react-redux";
import PeopleCard from "./peopleCard"
import { PropTypes } from 'prop-types';
import { useEffect, useState } from "react";
import { fetchOurPeopleTagData } from "../../redux/slice/ourPeopleTagPage";
import { retrunAssets } from "../../utils/getAssets";
import { DecodeHtml } from "../../utils/decodeHtml";
import PriorityCard from "./priorityCard";
const Peoples = ({ search, tag }) => {
    const dispatch = useDispatch()

    useEffect(() => {
        if (tag) {

            dispatch(fetchOurPeopleTagData(tag))
        }
    }, [tag])

    const store = useSelector(state => state.ourPeopleTag)
    const [peopleData, setPeopleData] = useState([])


    useEffect(() => {

        // debouncing
        const timer = setTimeout(() => {
            setPeopleData(store?.data?.data?.filter(people => {
                    return people?.peopleName.toLowerCase().includes(search?.toLowerCase())
                })
            )
        }, 800)
        return () => clearTimeout(timer)
    }, [search, store])



    const peoples = peopleData?.map(people => {
        return (
            {
                img: retrunAssets(people?.imageUrl),
                quote: people?.peopleName,
                designation: people?.designation,
                description: DecodeHtml({ html: people?.description }),
                location: people?.department,
                phone: people?.phone,
                email: people?.email,
                priority: people?.priority
            }
        )
    }).sort((a, b) => a.priority - b.priority);



    // Group peopleData by priority
    const groupedPeopleData = {};
    peoples?.forEach((person) => {
        const { priority } = person;
        if (!groupedPeopleData[priority]) {
            groupedPeopleData[priority] = [];
        }
        groupedPeopleData[priority].push(person);
    });


    return (

        <div className="flex items-center justify-center p-4 md:p-16 ">
            <div className="max-w-7xl w-full flex flex-col my-16  gap-8 h-fit">

                {

                    peoples?.length > 0 ?
                        Object.keys(groupedPeopleData).map((priority) => (
                            <div key={priority} className="grid grid-cols-1 md:grid-cols-2  lg:grid-cols-3 w-full place-items-center items-start gap-5 ">
                                {
                                    priority < 7 ?
                                        groupedPeopleData[priority].map((person, index) => (
                                            <PriorityCard key={index} people={person} />
                                        ))
                                        :
                                        groupedPeopleData[priority].map((person, index) => (
                                            <PeopleCard key={index} people={person} />
                                        ))
                                }
                            </div>
                        ))
                        :
                        <div className="w-full h-full flex items-center justify-center">
                            <p className="text-lg text-gray-500">No Data Found</p>
                        </div>
                }
            </div>
        </div>
    )
}
Peoples.propTypes = {
    tag: PropTypes.string
}
export default Peoples